var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{class:[
    'pa-0 ma-0 h-100 toolbar-container',
    {'compact': _vm.$vuetify.breakpoint.smAndDown},
    {'has-bottom-bar' : _setup.hasBottomBar},
  ],attrs:{"fluid":""}},[_c('div',{staticClass:"toolbar-content"},[_vm._t("toolbar")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }